import { createGlobalStyle, css } from 'styled-components';

function columnGenerator(suffix) {
	let style = '';

	for (let i = 1; i <= 12; i++) {
		style += suffix ? `.col-${suffix}-${i}` : `.col-${i}`;
		style += `{ width: ${(100 / 12) * i}% }`;
	}

	return style;
}

const HelperClass = createGlobalStyle`${css`
	.translate-x {
		&-100 {
			transform: translateX(100%);
		}
	}

	//! Fonts
	.font-montserrat-arm {
		&-regular {
			font-family: var(--montserrat_arm);
			font-weight: 400;
		}

		&-medium {
			font-family: var(--montserrat_arm);
			font-weight: 500;
		}

		&-bold {
			font-family: var(--montserrat_arm);
			font-weight: 600;
		}
	}

	//! Colors
	.background-color {
		color: var(--backgroundColor);
	}

	.main-color {
		color: var(--mainColor);
	}

	.border-color {
		color: var(--neutral600);
	}

	//! Grid
	.row {
		display: flex;
		flex-wrap: wrap;
		margin: 0 calc(var(--colPadding) * -1);

		> * {
			width: 100%;
			padding: 0 var(--colPadding);
		}

		/* //! 2560 */
		${columnGenerator()};

		/* //! 1920 */
		@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.desktopSizeXLMin}) {
			${columnGenerator('dxl')};
		}

		/* //! 1536 */
		@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.desktopSizeLMin}) {
			${columnGenerator('dl')};
		}

		/* //! 1366 */
		@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.desktopSizeMMin}) {
			${columnGenerator('dm')};
		}

		/* //! 1280 */
		@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.desktopSizeSMin}) {
			${columnGenerator('ds')};
		}

		/* //! 768 */
		@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.tabletSizeMin}) {
			${columnGenerator('t')};
		}

		/* //! Mobile */
		@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.tabletSizeSMin}) {
			${columnGenerator('m')};
		}
	}
`}`;

export default HelperClass;
